module.exports = __webpack_public_path__ + "img/48.73f0cd14.jpg";